// export const REACT_APP_BACKEND_URL = "https://lab2.api.supergitsa.com/api";
// export const REACT_APP_BACKEND_URL_TEST =
// 'https://mq85j3ll-8007.inc1.devtunnels.ms/api'
// export const REACT_APP_BACKEND_URL_TEST = "https://lab2.api.supergitsa.com/api";
// export const REACT_APP_BACKEND_URL_TEST ='https://lab2.api.supergitsa.com/api'
//   'https://mq85j3ll-8007.inc1.devtunnels.ms/api'
// export const REACT_APP_BACKEND_URL_TEST ="https://lab2.api.supergitsa.com/api";
//"https://q3spp5x0-8007.asse.devtunnels.ms/api";
export const REACT_APP_BACKEND_URL_TEST =
  // 'https://cottages-spencer-waiting-writer.trycloudflare.com/api'
  "https://lab2.api.supergitsa.com/api";
// 'https://lab2.api.supergitsa.com/api'
// "https://0jswrqw1-8080.inc1.devtunnels.ms/api";
// 'https://jzq6qslp-8080.asse.devtunnels.ms/api'
// "https://jzq6qslp-8080.asse.devtunnels.ms/api";
// 'https://celebs-kai-restoration-founded.trycloudflare.com/api'
// "https://90j4c2m1-8080.asse.devtunnels.ms/api";
//export const REACT_APP_BACKEND_URL_TEST =
//'https://6d5rc5cb-8080.inc1.devtunnels.ms/api'
// 'http://localhost:8080/api'
// export const REACT_APP_BACKEND_URL_TEST =
//"https://6d5rc5cb-8007.inc1.devtunnels.ms/api";
// export const REACT_APP_BACKEND_URL_TEST = 'https://labhisapi.supergitsa.com/api'
//  export const REACT_APP_BACKEND_URL_TEST = 'https://his2k.api.supergitsa.com/api'
// export const REACT_APP_BACKEND_URL_TEST =
//   'https://fairly-notable-koala.ngrok-free.app/api'
// export const REACT_APP_BACKEND_URL_TEST =
//   "https://mobile1.api.supergitsa.com/api";
// export const REACT_APP_BACKEND_URL = 'http://localhost:8007/api'
// export const REACT_APP_BACKEND_URL_TEST = 'http://localhost:8007/api'
// export const REACT_APP_BACKEND_URL_TEST ="https://mobile1.fe.supergitsa.com/api"
export const CurrentVersion = "3.3.0";
